/* ==========================================================================
   Royal Honey — honey universe
   Packs that set the quantity · minimum quantity · showcase slider
   ========================================================================== */
(() => {
  'use strict';

  const N = (window.SR = window.SR || {});
  const U = N.utils || {};
  const define = U.define || ((name, cls) => { if (!customElements.get(name)) customElements.define(name, cls); });
  const bus = U.bus || { on: () => {} };
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- Packs: one click sets the quantity ---------- */
  define('honey-packs', class extends HTMLElement {
    connectedCallback() {
      this.input = document.getElementById(this.dataset.target);
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-qty]');
        if (!btn) return;
        if (!this.input) { this.input = document.getElementById(this.dataset.target); }
        if (!this.input) return;
        this.input.value = btn.dataset.qty;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
        this.sync();
      });
      this.onQty = () => this.sync();
      this.input?.addEventListener('change', this.onQty);
      this.input?.addEventListener('input', this.onQty);
      bus.on('variant:rendered', () => this.sync());
      this.sync();
    }
    disconnectedCallback() {
      this.input?.removeEventListener('change', this.onQty);
      this.input?.removeEventListener('input', this.onQty);
    }
    sync() {
      const value = String(parseInt(this.input?.value || '0', 10));
      this.querySelectorAll('[data-qty]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.qty === value)));
    }
  });

  /* ---------- Minimum quantity on honey products ---------- */
  document.addEventListener('change', (e) => {
    const input = e.target.closest?.('input[data-honey-min]');
    if (!input) return;
    const min = parseInt(input.dataset.honeyMin, 10) || 1;
    const value = parseInt(input.value, 10);
    if (!value || value < min) input.value = String(min);
  }, true);

  /* ---------- Honey showcase: one product at a time ---------- */
  define('honey-showcase', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      if (this.slides.length < 2) return;
      this.index = 0;
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true)));
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1, true); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1, true); }
      });
      const delay = parseInt(this.dataset.autoplay || '0', 10);
      if (delay > 0 && !reduceMotion.matches) {
        const start = () => { clearInterval(this.timer); this.timer = setInterval(() => this.go(this.index + 1, false), delay * 1000); };
        const stop = () => clearInterval(this.timer);
        this.addEventListener('pointerenter', stop);
        this.addEventListener('pointerleave', start);
        this.addEventListener('focusin', stop);
        new IntersectionObserver(([entry]) => { if (entry.isIntersecting) start(); else stop(); }).observe(this);
      }
    }
    disconnectedCallback() { clearInterval(this.timer); }
    go(i, user) {
      const n = this.slides.length;
      this.index = (i + n) % n;
      this.slides.forEach((s, k) => {
        const on = k === this.index;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', String(!on));
        s.querySelectorAll('a, button').forEach((el) => { if (on) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1'); });
      });
      this.dots.forEach((d, k) => d.setAttribute('aria-current', String(k === this.index)));
      if (user) clearInterval(this.timer);
    }
  });
})();
